// Lets a mounted page register an "unsaved changes" guard so app-wide navigation
// triggers (hardware back button) can defer to it instead of navigating blindly.
// Only one page is ever guarded at a time in practice (route change unmounts the
// previous page), so a single module-level slot is sufficient.
let activeGuard = null;

export const registerUnsavedChangesGuard = (guard) => {
  activeGuard = guard;
};

export const clearUnsavedChangesGuard = () => {
  activeGuard = null;
};

export const getUnsavedChangesGuard = () => activeGuard;
